import React, { useState } from 'react'
import { FaThumbsUp, FaComment, FaInfoCircle } from 'react-icons/fa'
import officeImg from "../assets/office.png"
import UserImage from "../assets/user.png"
import moment from 'moment'
import { Link, useNavigate, useParams } from 'react-router-dom'

const AdOrgPost = ({ postAd }) => {
    const { organization } = useParams()
    const navigate = useNavigate()

    // console.log("postAd:",postAd)

    const images = postAd?.files[0]?.type === 'image' ? postAd?.files || [] : []
    const [focusedImg, setFocusedImg] = useState(images[0])

    return (
        <div className="ad-post-card">
            {/* Header */}
            <div className="ad-post-header">
                <div className="org-ad-info">
                    <img
                        src={postAd?.organization?.profileImage || officeImg}
                        alt="organization"
                        className="org-avatar"
                    />
                    <div>
                        <p className="org-name">{postAd?.organization?.name}</p>
                        <div className="post-meta">
                            <span>{moment(postAd?.createdAt).fromNow()}</span>
                            <span>{postAd?.audience}</span>
                        </div>
                    </div>
                </div>

                <Link to={`/user/${postAd?.createdBy?._id}`} className="author-info">
                    <img
                        src={postAd?.createdBy?.profilePic || UserImage}
                        alt="author"
                        className="author-avatar"
                    />
                    <h4>
                        {postAd?.createdBy?.firstname} {postAd?.createdBy?.lastname}
                    </h4>
                </Link>
            </div>

            {/* Content */}
            {postAd?.postText && (
                <p className="post-text">{postAd.postText}</p>
            )}

            {images.length > 0 && (
                <div className="post-media">
                    <div className="focused-image">
                        <img src={focusedImg?.url} alt="focused" />
                    </div>

                    <div className="image-thumbnails">
                        {images.map((img, i) => (
                            <img
                                key={i}
                                src={img.url}
                                alt=""
                                className={focusedImg === img ? 'active' : ''}
                                onClick={() => setFocusedImg(img)}
                            />
                        ))}
                    </div>
                </div>
            )}

            {postAd?.files[0]?.type === 'video' && (
                <div className="video-container">
                    <video controls src={postAd.files[0]} />
                </div>
            )}

            {/* Footer */}
            <div className="post-actions">
                <div>
                    <FaThumbsUp />
                    <span>{postAd?.likesCount || 0}</span>
                </div>
                <div>
                    <FaComment />
                    <span>{postAd?.commentsCount || 0}</span>
                </div>
            </div>

            {/* Promote CTA */}
             <button className="promote-btn" onClick={()=>navigate(`/${organization}/admin/promotions/posts/create`,{state:{ad:postAd,adType:"post"}})}>
                Promote
            </button>
        </div>
    )
}

export default AdOrgPost
